import React, { FC, ReactNode, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useSettings } from '@cigam/template/dist/hooks/useSettings';
import { useDispatch, useSelector } from 'src/store';
import { runtimeConfigs } from 'src/config/runtimeConfigs';
import {
  setHistoryNavigation,
  setUltimoPortalLogado,
} from 'src/Areas/Genericos/GE/slices/historyNavigation';

interface Props {
  children: ReactNode;
}

export const AuthRoute: FC<Props> = ({ children }) => {
  const { settings } = useSettings();
  const location = useLocation();
  const dispatch = useDispatch();
  const account = useSelector(state => state.account);
  const historyNavigation = useSelector(state => state.historyNavigation);

  const buscarUltimoPortal = (): string => {
    const path = location.pathname;
    if (path.includes('portal')) {
      const urlAtual = path.split('/');
      const portalAtivo =
        urlAtual.length > 0 && urlAtual[1].includes('portal')
          ? `${urlAtual[1]}`
          : '';
      dispatch(setUltimoPortalLogado(portalAtivo));
      return portalAtivo;
    }
    return '';
  };

  useEffect(() => {
    if (!account.user) {
      const path = location.pathname;

      dispatch(setHistoryNavigation(path));
      buscarUltimoPortal();
    }
  }, [account.user, dispatch, location.pathname]);

  if (!account.user) {
    let { defaultLogin } = settings;

    if (!defaultLogin) {
      const searchEnviroment = async () => {
        const enviroment = await runtimeConfigs();
        defaultLogin = enviroment.defaultLogin || 'cigam';
      };

      searchEnviroment();
    }

    if (typeof defaultLogin === 'string') {
      switch (defaultLogin) {
        case 'contato':
          return <Redirect to="/logincontato" />;
        default: {
          const ultimoPortal =
            historyNavigation.ultimoPortalLogado || buscarUltimoPortal();
          if (ultimoPortal) {
            return (
              <Redirect to={'../'.concat(ultimoPortal.concat('/login'))} />
            );
          }
          return <Redirect to="/login" />;
        }
      }
    }
  }

  if (account.tipoLogin !== 'cigam' && account.tipoLogin !== 'contato') {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};
